import { VolumeRenderingComponent } from './volume-rendering/volume-rendering.component';
import { EntityStoreService } from './../entity-store/entity-store.service';
import { MultiCanvasService } from './../multi-canvas/multi-canvas.service';
import { FovComponent } from './components/fov/fov.component';
import { CrossLineComponent } from './../cross-line/cross-line.component';
import { ToolEntityComponent } from './components/tool-entity/tool-entity.component';
import { CircleComponent } from './components/circle/circle.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { EntitiesService } from './entities.service';
import { CanvasComponent } from './components/canvas/canvas.component';
// import { BoundingboxComponent } from './components/boundingbox/boundingbox.component';
import { LineComponent } from './components/line/line.component';
import { CubeComponent } from './components/cube/cube.component';
// import { ColormapSelectorComponent } from './utils/colormap-selector/colormap-selector.component';
// import { WindowSelectorComponent } from './utils/window-selector/window-selector.component';
// import { SliceMenuComponent } from './utils/slice-menu/slice-menu.component';
import { PlaneComponent } from './components/plane/plane.component';
import { OrthographicCameraComponent } from './components/orthographic-camera/orthographic-camera.component';
import { MouseEntityComponent } from './controls/mouse/mouse-entity.component';
import { ControlsComponent } from './controls/controls/controls.component';
import { ResizePlaneComponent } from './controls/resize/resize-plane.component';
import { MovePlaneComponent } from './controls/move-plane/move-plane.component';
import { ResizePlaneEdgeComponent } from './controls/resize/resize-plane-edge/resize-plane-edge.component';
import { ResizePlaneCornerComponent } from './controls/resize/resize-plane-corner/resize-plane-corner.component';
import { EntitiesService } from './entities.service';
import { OrbitControlsComponent } from './controls/orbit-controls/orbit-controls.component';
import { PerspectiveCameraComponent } from './components/perspective-camera/perspective-camera.component';
import { SphereComponent } from './components/sphere/sphere.component';
import { RingComponent } from './components/ring/ring.component';
import { ObjLoaderComponent } from './loader/obj-loader/obj-loader.component';
import { VrmlLoaderComponent } from './loader/vrml-loader/vrml-loader.component';
import { ShapeComponent } from './components/shape/shape.component';
import { ProfileComponent } from './components/profile/profile.component';
import { InfoComponent } from './components/info/info.component';
import { EventDistributeComponent } from './event-distribute/event-distribute.component';
// import { LocalImageLoaderComponent } from './loader/local-image-loader/local-image-loader.component';
// import { ColormapComponent } from './utils/colormap/colormap.component';
// import { DirectionComponent } from './utils/direction/direction.component';
// import { WindowComponent } from './utils/window/window.component';

@NgModule({
  declarations: [
    CanvasComponent,
    LineComponent,
    CubeComponent,
    PlaneComponent,
    OrthographicCameraComponent,
    MouseEntityComponent,
    ControlsComponent,
    ResizePlaneComponent,
    MovePlaneComponent,
    ResizePlaneEdgeComponent,
    ResizePlaneCornerComponent,
    OrbitControlsComponent,
    PerspectiveCameraComponent,
    SphereComponent,
    CircleComponent,
    RingComponent,
    ObjLoaderComponent,
    ProfileComponent,
    VrmlLoaderComponent,
    ShapeComponent,
    ToolEntityComponent,
    CrossLineComponent,
    InfoComponent,
    EventDistributeComponent,
    FovComponent,
    VolumeRenderingComponent
  ],
  providers: [EntitiesService, EntityStoreService],
  imports: [CommonModule],
  exports: [
    CanvasComponent,
    CubeComponent,
    LineComponent,
    PlaneComponent,
    OrthographicCameraComponent,
    MouseEntityComponent,
    ResizePlaneComponent,
    MovePlaneComponent,
    OrbitControlsComponent,
    PerspectiveCameraComponent,
    SphereComponent,
    CircleComponent,
    RingComponent,
    ObjLoaderComponent,
    VrmlLoaderComponent,
    ShapeComponent,
    ProfileComponent,
    ToolEntityComponent,
    CrossLineComponent,
    InfoComponent,
    EventDistributeComponent,
    FovComponent,
    VolumeRenderingComponent
  ],
})
export class NgThreeModule {}
